import React from 'react';

import Framework from "@beardeddevops/react.framework";
import UserRoles from "constants/UserRoles";
import FERadiusMap from "../../../../../components/Containers/FERadiusMap";

const breadcrumbsStatic = [{
	name: 'Users',
	url: '/users',
	icon: 'dashboard',
}];

export default class RadiusMap extends Framework.Components.View {

	access = [UserRoles.Admin, UserRoles.Manager, UserRoles.Dispatch, UserRoles.HelpDesk];

	render() {
		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: "FE Radius Map",
				url: `/users/feradius`,
				icon: 'compass',
			}
		]);

		let {
			history,
			reloadShell,
			baseUrl,
			roles,
		} = this.props;

		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}/>

				<FERadiusMap
					history={history}
					baseUrl={baseUrl}
					reloadShell={reloadShell}
					roles={roles}
					refresh={this.state.refresh}
				/>
			</div>
		);
	}
}


